import { faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { cartPostAction, getCartItems } from "../../actions/cartAction";
import { getPatientNotification } from "../../actions/dashboardAction";
import RxIcon from "../../assets/images/rx-icon.png";
import { getUserDetail } from "../../utils/helper";
import ConfirmDialog from "../ConfirmDialog";
import { getShippingPrice } from "../../actions/profileAction";
const CartItem = ({ item, shipping }) => {
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  const role = useSelector((state) => state.role.role);
  const dispatch = useDispatch();
  const removeItem = () => {
    var params = {
      params: {
        action: "removeCartItem",
        itemId: item.prescriptionId,
        isPrescription: 1,
        token: getUserDetail()?.token,
      },
    };
    dispatch(
      cartPostAction(params, () => {
        dispatch(getCartItems(role.val));
        dispatch(getPatientNotification(role.val));
        dispatch(getShippingPrice(shipping.address_id));
      })
    );
  };
  return (
    <tr>
      {showConfirmDialog && (
        <ConfirmDialog
          title="Are you sure want to remove this item?"
          acceptAction={removeItem}
          acceptText="yes"
          rejectText="no"
          closePopup={() => setShowConfirmDialog(false)}
        />
      )}
      <td style={{ textAlign: "center" }}>
        <a className="formula_link" onClick={() => setShowConfirmDialog(true)}>
          <FontAwesomeIcon icon={faTimesCircle} />
        </a>
      </td>
      <td>
        <div className="icon">
          <img src={RxIcon} alt="rx-icon" />
        </div>
      </td>
      <td>
        {item.description}
        <span>
          <br />
          Preparation Method: {item.prep_name}
        </span>
        {item.formula ? (
          <span>
            <br />
            Formula Name: {item.formula}
          </span>
        ) : (
          ""
        )}
      </td>
      <td style={{ textAlign: "right" }}>
        <span>
          {parseFloat(item.weight).toLocaleString("en-US", {
            maximumFractionDigits: 1,
            minimumFractionDigits: 1,
          })}{" "}
          grams
        </span>
      </td>
      <td style={{ textAlign: "right" }}>
        <span>
          {parseFloat(item.total).toLocaleString("en-US", {
            maximumFractionDigits: 2,
            minimumFractionDigits: 2,
            style: "currency",
            currency: "USD",
          })}
        </span>
      </td>
      <td></td>
    </tr>
  );
};
export default CartItem;
